<div *ngIf="!this.modifyQuery" class="ui-g-6">
  <h1 class="step-title">{{ 'customerSetBuilder.createClusterQuery' | translate }}</h1>
</div>
<div *ngIf="this.modifyQuery" class="ui-g-6">
  <h1 class="step-title">{{ 'customerSetBuilder.updateClusterQuery' | translate }}</h1>
</div>
<!-- Set/Query Operations -->
<div class="ui-g-6 text-right">
  <button
    pButton
    *ngIf="modifyQuery"
    type="button"
    class="k-generic-btn"
    icon="fa fa-arrow-left"
    iconPos="left"
    label="{{ 'common.back' | translate }}"
    (click)="goBack()">
  </button>
  <button
    pButton
    type="button"
    class="k-generic-btn"
    icon="fa fa-search"
    iconPos="left"
    label="{{ 'customerSetBuilder.loadSet' | translate }}"
    (click)="openSetLoad()">
  </button>
  <button
    pButton
    *ngIf="!this.modifyQuery"
    type="button"
    class="k-generic-btn"
    icon="fa fa-floppy-o"
    iconPos="left"
    label="{{ 'customerSetBuilder.saveSet' | translate }}"
    (click)="openSetSave()">
  </button>
  <button
    pButton
    *ngIf="this.modifyQuery"
    type="button"
    class="k-generic-btn"
    icon="fa fa-floppy-o"
    iconPos="left"
    label="{{ 'customerSetBuilder.updateQuery' | translate }}"
    (click)="updateSet()">
  </button>
  <button
    pButton
    *ngIf="this.modifyQuery"
    type="button"
    class="k-generic-btn"
    icon="fa fa-floppy-o"
    iconPos="left"
    label="{{ 'customerSetBuilder.updatePlanning' | translate }}"
    (click)="updatePlanningDate()">
  </button>
</div>
<!-- Query Builder -->
<div class="ui-g-12">
  <h1 *ngIf="setCode">{{ 'customerSetBuilder.setName' | translate }}: {{ setCode }} (v{{ setVersion }})</h1>
  <p *ngIf="setDescription">{{ 'customerSetBuilder.setDescription' | translate }}: {{ setDescription }}</p>
  <app-kv-ext-search
    #queryBuilder
    *ngIf="extSearchConfig"
    [query]="extSearchQuery"
    [config]="extSearchConfig"
    [showSendQueryBtn]="false"
    [openedAccordion]="true"
  ></app-kv-ext-search>
</div>
<div class="ui-g-12 text-right">
  <!-- Create Cluster Button-->
  <button
    pButton
    class="k-generic-btn"
    type="button"
    (click)="openCreateCluster()"
    label="{{ 'customerSetBuilder.createCluster' | translate }}">
  </button>
  <!-- Check Results Button -->
  <button
    pButton
    type="button"
    class="k-generic-btn"
    icon="fa fa-eye"
    iconPos="left"
    label="{{ 'customerSetBuilder.checkResults' | translate }}"
    (click)="checkResults()">
  </button>
  <!-- Executions List Button
  <button
    pButton
    type="button"
    class="k-generic-btn"
    icon="fa fa-list-alt"
    iconPos="left"
    label="{{ 'customerSetBuilder.executionsHistorical' | translate }}"
    [disabled]="!setId"
    (click)="checkSetExecutions()">
  </button> -->
</div>
<!-- Storico Esecuzioni nuovo, no button/popup-->
<div class="ui-g-12">
  <app-customer-set-execution-list
    *ngIf="setId"
    [queryId]="setId.id">
  </app-customer-set-execution-list>
</div>

<!-- Dialog Save/Load/Check -->
<p-dialog
  [header]="planningDate ? planningTitle : dialogTitle"
  [minWidth]="600"
  [width]="600"
  [(visible)]="showDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()">
    <app-customer-set-save
      *ngIf="showSetSave"
      [setCode]="setCode"
      [setDescription]="setDescription"
      [extSearchQuery]="extSearchQuery"
      [executionType]="executionType"
      [singleExecDate]="singleExecDate"
      [recExecStartDate]="recExecStartDate"
      [recExecEndDate]="recExecEndDate"
      [cronJobsFrequency]="cronJobsFrequency"
      [clusterHeadId]="clusterHeadId"
      [planningDate]="planningDate"
      [saveQuery]="saveQuery"
      [enabled]="enabled"
      [enabledDeleteCustomer]="enabledDeleteCustomer"
      (onSaveSet)="saveSet($event)"
      (onCloseDialog)="closeDialog()">
    </app-customer-set-save>
    <app-customer-set-load
      *ngIf="showSetLoad"
      (onCloseDialog)="closeDialog()"
      (onSelectQuery)="loadSet($event)">
    </app-customer-set-load>
    <app-customer-set-results
      *ngIf="showSetResults"
      [results]="setResults"
      (onExportResults)="exportResults()"
      (onCloseDialog)="closeDialog()">
    </app-customer-set-results>
</p-dialog>

<p-dialog
  class="cluster-dialog"
  [positionTop]="50"
  [width]="1700"
  [minWidth]="1700"
  [header]="dialogTitle"
  [(visible)]="showSetExecutions"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()">
  <app-customer-set-execution-list
    *ngIf="showSetExecutions"
    [queryId]="setId.id">
  </app-customer-set-execution-list>
</p-dialog>

<p-dialog
  [width]="400"
  [minWidth]="300"
  [header]="warningTitle"
  [(visible)]="showAlreadyExist"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeAlready()">
  <span>{{this.message }}</span>
  <br><br>
  <button
  type="button"
  pButton
  class="ui-button-info btnDelete"
  (click)="closeAlready()"
  label="{{ 'common.ok' | translate }}">
</button>
</p-dialog>

<p-dialog
class="cluster-dialog"
  *ngIf="showCreateCluster"
  [(visible)]="showCreateCluster"
  [modal]="true"
  header=""
  [minWidth]="900"
  [positionTop]="50"
  [minHeight]="700"
  [draggable]="false"
  [responsive]="true"
  [resizable]="false"
  (onHide)="closeCreateCluster()">
 <app-form-cluster-loyalty [backButton]="false" [isPopUp]="true" (closePopUp)="closeCreateCluster()"></app-form-cluster-loyalty>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-builder/customer-set-builder.component.html